import React, { FunctionComponent } from 'react';
import { Flex, Image, TableCell, TableRow, Text } from '@bitrise/bitkit';
import { StepSummary } from '@trace/types';
import getFormattedValue from '../../../utils/metric/getFormattedValue';
import BuildSuccessRate from '../BuildSuccessRate/BuildSuccessRate';
import ChangeBadge from '../../ChangeBadge/ChangeBadge';
import StatusHistory from '../StatusHistory/StatusHistory';

interface Props {
  dataSummary: StepSummary;
  isError: boolean;
  isFetching: boolean;
  refetch: () => void;
}

const StepsBreakdownTableRow: FunctionComponent<Props> = ({ dataSummary }) => {
  const { trendChange, id, title, totalRuns, totalRunsSuccess, totalRunTimeSuccess } = dataSummary;

  return (
    <TableRow height="85px">
      <TableCell breakOn="none">
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x2">
          <Flex>
            <Image
              borderRadius="x1"
              height="35px"
              src={`https://bitrise-steplib-collection.s3.amazonaws.com/steps/${id}/assets/icon.svg`}
              width="35px"
            />
          </Flex>

          <Flex>{title}</Flex>
        </Flex>
      </TableCell>

      <TableCell breakOn="none">
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x3">
          <Flex>
            <Text>{getFormattedValue('seconds', totalRunTimeSuccess / totalRunsSuccess)}</Text>
          </Flex>

          <Flex>
            <ChangeBadge change={trendChange} positiveDelta={-1} />
          </Flex>
        </Flex>
      </TableCell>

      <TableCell breakOn="none">{getFormattedValue('seconds', dataSummary.totalRunTime)}</TableCell>

      <TableCell shrink>
        <BuildSuccessRate
          radius={30}
          strokeWidthInner={4}
          strokeWidthOuter={8}
          textConfig="8"
          totalBuilds={totalRuns}
          totalBuildsSuccess={totalRunsSuccess}
        />
      </TableCell>

      <TableCell shrink>
        <StatusHistory builds={dataSummary.runsTail} size={24} />
      </TableCell>
    </TableRow>
  );
};

export default StepsBreakdownTableRow;
